<template>
  <div class="policy section">
    <div class="container">
      <div class="row">
        <div class="post-box">
          <div class="text-box">
            <h2>CONDITIONS GENERALES D'UTILISATIONS DE KIRA RH</h2>
            <p>
              Veuillez lire avec attention les présentes conditions générales
              d’utilisation. Nous vous invitons à faire de même avec la
              politique de confidentialité faisant partie intégrante des
              présentes.<br />

              Le site <a href="https://kirarh.fr">kirarh.fr</a> édité par la
              société KiraRH est une plateforme de mise en relation des
              recruteurs et des candidats. Il assure la diffusion d’offres
              d’emploi auxquelles les candidats peuvent directement postuler via
              un espace qui leur est dédié. Il dispose également d’une CVthèque
              (base de données hébergeant les CV) exclusivement accessible aux
              employeurs ayant souscrit à ce service.<br />

              Nous vous invitons à nous contacter via l’onglet « Contact » de
              notre site internet pour toute autre question ou information.
            </p>

            <h3>OBJET :</h3>
            <p>
              Nos présentes conditions générales d’utilisation ont pour objet de
              définir les conditions selon lesquelles les utilisateurs peuvent
              accéder et utiliser nos services. Leur acceptation suppose de la
              part des utilisateurs qu’ils jouissent de la capacité juridique
              nécessaire pour cela, ou à défaut qu’ils ont l’autorisation d’un
              tuteur ou de leur représentant légal (cas des mineurs)
            </p>
            <p>
              Le présent document est un contrat conclu entre les différents
              utilisateurs (candidat ou particulier, employeur ou professionnel)
              du site www.kirarh.fr et la société kirarh
            </p>
            <h3>DEFINITIONS</h3>
            <p>
              Site : site internet accessible via le nom de domaine :
              www.kirarh.fr<br />
              Editeur : la société Kirarh, éditeur du site. L’éditeur a reçu de
              la part du propriétaire de la plateforme<br />
              Internet, de la marque et du nom de domaine utilisés par le site,
              l’autorisation d’exploiter ceux-ci<br />
              Candidat : toute personne physique ayant procédé à son inscription
              sur le site<br />
              Employeur / Recruteur / Client : tout utilisateur physique ou
              moral agissant dans le cadre de son activité<br />
              professionnelle ayant procédé à son inscription et souscrivant aux
              services payants ou gratuits de la<br />
              société kiraRh, y compris la réservation d’un espace de
              publication de contenu<br />
              CVthèque : base de données de CV enregistrés par les utilisateurs
              « candidats », « employeurs » et<br />
              accessible via le site aux clients/ Employeur ayant souscrit au
              service « CVthèque »<br />
              Curriculum Vitae : document établi par l’utilisateur candidat
              détaillant son parcours académique, professionnel ainsi que ses
              compétences acquises.
            </p>
            <h3>CONDITIONS D'ACCÈS AU SITE :</h3>
            <p>
              En accédant au site, l’utilisateur reconnaît avoir lu, compris et
              accepté les présentes Conditions Générales et informations
              légales. Par conséquent, il reconnaît que tout accès au site le
              lie contractuellement à kiraRH selon les termes des présentes.
            </p>
            <p>
              L’accès aux services qui lui sont accessibles est à durée
              indéterminée, sauf modification du site par KiraRH.
            </p>
            <h3>SERVICES PROPOSES :</h3>
            <p>
              La société met à disposition des Utilisateurs, via le site
              kiraRH.fr : <br />

              Des services gratuits accessibles à tout utilisateur : Recherche,
              accès et consultation de contenu, personnalisation du contenu<br />
              Des services gratuits accessibles aux utilisateurs candidats :
              Mise en relation directe ou via la Cvthèque avec les clients
              (employeurs). Personnalisation du contenu (CV) en fonction du
              profil. Création d’alertes d’opportunités d’emploi. Vulgarisation
              (possibilité de le rendre anonyme) du profil dans la CVthèque sur
              consentement préalable de l’utilisateur candidat. L’utilisateur
              Candidat est expressément informé que, dans le cadre de son
              Inscription, l’ensemble des Services proposé par KiraRH lui sera
              accessible.
              <br />
              Il est possible à tout moment pour l’utilisateur de modifier les
              paramètres dans son Espace personnel, de procéder à la résiliation
              de son Inscription à l’un ou la totalité des services.
              <br />
              Des services payants accessibles aux employeurs / Clients : -
              Accès à la CVthèque<br />

              - Diffusion d’annonce<br />

              - Réservation d’espaces publicitaires <br />

              La souscription à ces services suppose l’acceptation préalable
              sans réserve des Conditions Générales de Vente Kira RH par le
              client.
            </p>

            <h3>INSCRIPTION - ESPACE PERSONNEL</h3>
            <p>
              Pour accéder à son espace personnel, l’utilisateur doit au
              préalable s’inscrire sur le site KiraRH qui lui enverra par la
              suite un lien de confirmation. Pour ce faire, une adresse mail
              valide et un mot de passe sont indispensables. En validant son
              inscription, le Candidat souscrit (équivaut à) par défaut à
              l’ensemble des Services du site kirarh.fr La suppression de votre
              compte entraîne la résiliation pure et simple de l’ensemble des
              Services. L’utilisateur est l’unique responsable de la
              préservation de la confidentialité de ses identifiants. En cas
              d’oubli, ou de suspicion de connexion frauduleuse à son compte,
              l’utilisateur Candidat ou le Client / employeur doit immédiatement
              contacter les administrateurs du site à l’adresse
              <a href="mailto: recrutement@kirarh.fr">recrutement@kirarh.fr</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notice",
};
</script>

<style scoped></style>
